import { useEffect, useState } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { bindUnauthorizedRedirect, clearAuth, isAuthenticated, restoreAuth } from "./auth"

/** Route guard for /admin/*. Redirects to the login page when unauthenticated or expired. */
export default function RequireAuth(): React.JSX.Element {
	const location = useLocation()
	const [checked, setChecked] = useState(false)
	const [authed, setAuthed] = useState(false)

	useEffect(() => {
		bindUnauthorizedRedirect()
		restoreAuth()
		const ok = isAuthenticated()
		if (!ok) clearAuth()
		setAuthed(ok)
		setChecked(true)
	}, [])

	// Avoid flashing protected content / redirecting during SSR hydration.
	if (!checked) return <div className="p-8 text-muted-foreground">Cargando…</div>

	if (!authed) {
		return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
	}

	return <Outlet />
}
